// src/pages/AdminDashboard.js - СО БЛОГ И ТЕМА (Без фиксно копче)
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Grid,
    Card,
    CardContent,
    Typography,
    Box,
    Chip
} from '@mui/material';
import {
    FitnessCenter,
    People,
    TrendingUp,
    SportsMartialArts,
    Restaurant,
    Article
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import AdminHeader from '../components/AdminHeader';

const AdminDashboard = () => {
    const { user, isAuthenticated, loading } = useAuth();
    const { isDarkMode } = useTheme();
    const navigate = useNavigate();
    const [stats, setStats] = useState({
        totalPrograms: 0,
        totalUsers: 0,
        totalTrainings: 0,
        totalDiets: 0,
        totalBlogPosts: 0
    });

    useEffect(() => {
        if (!loading && (!isAuthenticated || user?.role !== 'ADMIN')) {
            navigate('/login');
        }
    }, [isAuthenticated, user, loading, navigate]);

    const handleTrainGymClick = () => {
        navigate('/admin/train-gym');
    };

    const handleDietsClick = () => {
        navigate('/diets');
    };

    const menuItems = [
        {
            title: 'Програми',
            description: 'Управувај со фитнес програми',
            icon: <FitnessCenter sx={{ fontSize: 40 }} />,
            color: '#ff7eb9',
            bgColor: isDarkMode ? 'rgba(255, 126, 185, 0.15)' : 'rgba(255, 126, 185, 0.1)',
            onClick: () => navigate('/admin/programs'),
            count: stats.totalPrograms
        },
        {
            title: 'Блог',
            description: 'Управувај со статии и содржина',
            icon: <Article sx={{ fontSize: 40 }} />,
            color: '#2196F3',
            bgColor: isDarkMode ? 'rgba(33, 150, 243, 0.15)' : 'rgba(33, 150, 243, 0.1)',
            onClick: () => navigate('/admin/blog'),
            count: stats.totalBlogPosts
        },
        {
            title: 'Диети',
            description: 'Управувај со диететски планови',
            icon: <Restaurant sx={{ fontSize: 40 }} />,
            color: '#4CAF50',
            bgColor: isDarkMode ? 'rgba(76, 175, 80, 0.15)' : 'rgba(76, 175, 80, 0.1)',
            onClick: () => navigate('/admin/diets'), // ✅ PROMENETO od /diets na /admin/diets
            count: stats.totalDiets
        },
        {
            title: 'Корисници',
            description: 'Управувај со корисници',
            icon: <People sx={{ fontSize: 40 }} />,
            color: '#FFA726',
            bgColor: isDarkMode ? 'rgba(255, 167, 38, 0.15)' : 'rgba(255, 167, 38, 0.1)',
            onClick: () => navigate('/admin/users'),
            count: stats.totalUsers
        },
        {
            title: 'Управувај со секции',
            description: 'Уреди За нас и Достигнувања',
            icon: <SportsMartialArts sx={{ fontSize: 40 }} />,
            color: '#AB47BC',
            bgColor: isDarkMode ? 'rgba(171, 71, 188, 0.15)' : 'rgba(171, 71, 188, 0.1)',
            onClick: () => navigate('/admin/sections'),
            count: '📝'
        },
        {
            title: 'Аналитика',
            description: 'Преглед на статистики',
            icon: <TrendingUp sx={{ fontSize: 40 }} />,
            color: '#EF5350',
            bgColor: isDarkMode ? 'rgba(239, 83, 80, 0.15)' : 'rgba(239, 83, 80, 0.1)',
            onClick: () => navigate('/admin/analytics'),
            count: '📊'
        }
    ];

    if (loading) {
        return (
            <Container>
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                    <Typography variant="h6">Вчитување...</Typography>
                </Box>
            </Container>
        );
    }

    if (!isAuthenticated || user?.role !== 'ADMIN') {
        return null;
    }

    return (
        <Box sx={{
            py: 4,
            minHeight: '100vh',
            backgroundColor: 'background.default',
            transition: 'background-color 0.3s ease'
        }}>
            <Container maxWidth="lg">
                {/* AdminHeader има Theme Toggle копче */}
                <AdminHeader />

                {/* Welcome Section */}
                <Box sx={{ mb: 6, textAlign: 'center' }}>
                    <Typography
                        variant="h2"
                        sx={{
                            color: 'primary.main',
                            fontWeight: 'bold',
                            mb: 2,
                            textShadow: isDarkMode ? '0 0 20px rgba(255, 126, 185, 0.5)' : 'none'
                        }}
                    >
                        🎯 Админ Панел
                    </Typography>
                    <Typography variant="h5" color="text.secondary" sx={{ mb: 3 }}>
                        Добредојде, {user?.name || user?.email}!
                    </Typography>
                    <Chip
                        label="АДМИНИСТРАТОР"
                        sx={{
                            bgcolor: 'primary.main',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            px: 2,
                            py: 1,
                            boxShadow: isDarkMode ? '0 4px 15px rgba(255, 126, 185, 0.4)' : '0 4px 15px rgba(255, 126, 185, 0.3)'
                        }}
                    />
                </Box>

                {/* Menu Grid */}
                <Grid container spacing={3} justifyContent="center">
                    {menuItems.map((item, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card
                                sx={{
                                    height: '100%',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    border: `2px solid ${item.color}20`,
                                    borderRadius: 3,
                                    bgcolor: 'background.paper',
                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: isDarkMode
                                            ? `0 12px 40px ${item.color}50`
                                            : `0 12px 40px ${item.color}30`,
                                        borderColor: item.color,
                                    }
                                }}
                                onClick={item.onClick}
                            >
                                <CardContent sx={{ p: 4 }}>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Box
                                            sx={{
                                                width: 80,
                                                height: 80,
                                                borderRadius: 3,
                                                backgroundColor: item.bgColor,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                margin: '0 auto 16px auto',
                                                color: item.color,
                                                border: `2px solid ${item.color}30`,
                                                transition: 'all 0.3s ease',
                                            }}
                                        >
                                            {item.icon}
                                        </Box>

                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontWeight: 'bold',
                                                color: item.color,
                                                mb: 1
                                            }}
                                        >
                                            {item.title}
                                        </Typography>

                                        <Typography
                                            variant="body1"
                                            color="text.secondary"
                                            sx={{ mb: 2 }}
                                        >
                                            {item.description}
                                        </Typography>

                                        <Chip
                                            label={item.count}
                                            sx={{
                                                bgcolor: item.color,
                                                color: 'white',
                                                fontWeight: 'bold',
                                                fontSize: '0.9rem'
                                            }}
                                        />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                {/* Footer Info */}
                <Box sx={{
                    mt: 6,
                    textAlign: 'center',
                    py: 4,
                    bgcolor: isDarkMode ? 'rgba(255, 255, 255, 0.03)' : '#f5f5f5',
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#e0e0e0'
                }}>
                    <Typography variant="h6" sx={{
                        color: 'text.secondary',
                        mb: 2,
                        fontWeight: 'bold'
                    }}>
                        📋 Админ Панел Информации
                    </Typography>
                    <Grid container spacing={2} justifyContent="center">
                        {[
                            { count: stats.totalPrograms, label: 'Програми', color: '#ff7eb9' },
                            { count: stats.totalBlogPosts, label: 'Статии', color: '#2196F3' },
                            { count: stats.totalDiets, label: 'Диети', color: '#4CAF50' },
                            { count: stats.totalUsers, label: 'Корисници', color: '#FFA726' },
                            { count: stats.totalTrainings, label: 'Тренинзи', color: '#AB47BC' }
                        ].map((stat, idx) => (
                            <Grid item xs={12} sm={6} md={2.4} key={idx}>
                                <Box sx={{
                                    p: 2,
                                    bgcolor: 'background.paper',
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#e0e0e0',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        boxShadow: isDarkMode
                                            ? `0 8px 20px ${stat.color}40`
                                            : `0 8px 20px ${stat.color}20`,
                                        borderColor: stat.color
                                    }
                                }}>
                                    <Typography variant="h6" sx={{
                                        color: stat.color,
                                        fontWeight: 'bold'
                                    }}>
                                        {stat.count}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {stat.label}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
                        🕒 Последно ажурирано: {new Date().toLocaleDateString('mk-MK')}
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default AdminDashboard;